import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "section d-flex flex-wrap justify-content-between p-3",
  style: {"flex-direction":"column"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "coupon-codes d-flex"
}
const _hoisted_4 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.benefit-name')) + ": " + _toDisplayString(_ctx.benefit.benefitName), 1),
    (_ctx.benefit.expirationDateAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('cashier.response.expiration-date')) + ": " + _toDisplayString(_ctx.benefit.expirationDate), 1))
      : _createCommentVNode("", true),
    (_ctx.showCodes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('cashier.response.coupon-codes')), 1),
          _createTextVNode(":  " + _toDisplayString(_ctx.benefit.couponCodes.join(', ')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCodes)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCodes = !_ctx.showCodes)),
          class: "link pt-2"
        }, _toDisplayString(_ctx.$t('cashier.benefit.hide-codes')), 1))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCodes = !_ctx.showCodes)),
          class: "link pt-2"
        }, _toDisplayString(_ctx.$t('cashier.benefit.show-codes')), 1))
  ]))
}